import { GenericPortalError } from "../components/error-display/PortalError";

class DossierService {
  async createDossierInstance(config, token, projectId, dossierId) {
    const options = {
      method: "POST",
      credentials: "include", // Including cookie
      mode: "cors", // Setting as cors mode for cross origin
      headers: {
        "content-type": "application/json",
        accept: "application/json",
        "X-MSTR-AuthToken": token,
        "x-mstr-projectid": projectId,
      },
    };
    let response = await fetch(
      config.backendServiceURL + "api/dossiers/" + dossierId + "/instances",
      options,
    );

    if (response.ok) {
      return response.json();
    } else {
      const res = await response.json();

      if (response.status === 401) {
        throw GenericPortalError("INVALID_CREDENTIALS", "error", res);
      } else {
        throw GenericPortalError("ERROR_INSTANCE_CREATION", "error", res);
      }
    }
  }
}

export const dossierService = new DossierService();
